(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vp-community"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vp-customer-count')) {
    customElements.define('vp-customer-count', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || this.complete) return;
        this.finalText = this.textContent;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'fi');
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.textContent = '0';
          const started = performance.now();
          const update = now => {
            const progress = Math.min((now - started) / 1500, 1);
            this.textContent = this.formatter.format(Math.round(20000 * (1 - Math.pow(1 - progress, 3))));
            if (progress < 1) {
              this.frame = requestAnimationFrame(update);
            } else {
              this.textContent = this.finalText;
              this.complete = true;
              this.classList.add('is-complete');
            }
          };
          this.frame = requestAnimationFrame(update);
        }, { threshold: .5 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        if (this.finalText) this.textContent = this.finalText;
        this.observer = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vp-gift-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vp-gift-product')) {
    customElements.define('vp-gift-product', class extends HTMLElement {
      connectedCallback() {
        if (this.giftReady) return;
        this.giftReady = true;
        this.addEventListener('change', (event) => {
          const choice = event.target.closest('[data-gift-cents]');
          if (!choice || !choice.checked) return;
          const amount = Number(choice.dataset.giftCents);
          const tier = amount >= 100000 ? 'ruby' : amount >= 50000 ? 'emerald' : amount >= 30000 ? 'gold' : amount >= 20000 ? 'platinum' : amount >= 15000 ? 'amethyst' : amount >= 10000 ? 'onyx' : amount >= 5000 ? 'silver' : amount >= 2500 ? 'copper' : 'pearl';
          const art = this.querySelector('[data-gift-tier]');
          art.classList.remove('vp-gift-art--' + art.dataset.giftTier);
          art.dataset.giftTier = tier;
          art.classList.add('vp-gift-art--' + tier);
          this.querySelector('[data-gift-art-amount]').textContent = choice.dataset.giftMoney;
          this.querySelector('[data-gift-price] sale-price').textContent = choice.dataset.giftPriceMoney;
          this.querySelector('input[name="id"]').value = choice.value;
          const address = new URL(window.location.href);
          address.searchParams.set('variant', choice.value);
          window.history.replaceState({}, '', address);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vp-social-stats"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vp-social-stats')) {
    customElements.define('vp-social-stats', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.counters = Array.from(this.querySelectorAll('[data-vp-social-count]'));
        this.numberFormat = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, { maximumFractionDigits: 0 });
        this.render(1);
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.render(0);
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          let startedAt;
          const animate = timestamp => {
            if (startedAt === undefined) startedAt = timestamp;
            const progress = Math.min((timestamp - startedAt) / 1000, 1);
            this.render(1 - Math.pow(1 - progress, 3));
            if (progress < 1) this.frame = requestAnimationFrame(animate);
            else this.classList.add('is-complete');
          };
          this.frame = requestAnimationFrame(animate);
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }
      render(progress) {
        this.counters.forEach(counter => {
          const value = Math.round(Number(counter.dataset.vpSocialCount) * progress);
          counter.textContent = this.numberFormat.format(value) + counter.dataset.suffix;
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.counters) this.render(1);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vp-trust-stories"] && !Shopify.designMode) return;
  try {
    (function(){
if(window.vpTrustStoriesReady)return;
window.vpTrustStoriesReady=true;
const animations=new WeakMap();
const gestures=new WeakMap();
const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
function syncPause(dialog){
const state=animations.get(dialog);
if(!state)return;
if(state.held||state.paused||document.hidden)state.animation.pause();else state.animation.play();
}
function selectStory(dialog,index){
const previous=animations.get(dialog);
if(previous)previous.animation.cancel();
animations.delete(dialog);
const panels=Array.from(dialog.querySelectorAll('[data-vp-story-panel]'));
const nextIndex=(index+panels.length)%panels.length;
dialog.dataset.vpStoryIndex=String(nextIndex);
panels.forEach((panel,panelIndex)=>{panel.hidden=panelIndex!==nextIndex;});
const buttons=Array.from(dialog.querySelectorAll('[data-vp-story-step]'));
buttons.forEach((button,buttonIndex)=>{
if(buttonIndex===nextIndex)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');
button.querySelector('span').style.transform=buttonIndex<nextIndex?'scaleX(1)':'scaleX(0)';
});
if(reducedMotion.matches){buttons[nextIndex].querySelector('span').style.transform='scaleX(1)';return;}
const animation=buttons[nextIndex].querySelector('span').animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}],{duration:10000,easing:'linear',fill:'forwards'});
const state={animation,held:false,paused:false};
animations.set(dialog,state);
animation.onfinish=function(){
if(!dialog.open||animations.get(dialog)!==state)return;
if(nextIndex===panels.length-1)dialog.close();else selectStory(dialog,nextIndex+1);
};
syncPause(dialog);
}
document.addEventListener('click',function(event){
const open=event.target.closest('[data-vp-story-open]');
if(open){
const keyboardOpen=event.detail===0;
const dialog=open.closest('.vp-stories').querySelector('dialog');
dialog.showModal();
document.documentElement.classList.add('vp-story-open');
selectStory(dialog,Number(open.dataset.vpStoryOpen));
dialog.focus({preventScroll:true});
dialog.addEventListener('close',function(){
const state=animations.get(dialog);
if(state)state.animation.cancel();
animations.delete(dialog);
gestures.delete(dialog);
document.documentElement.classList.remove('vp-story-open');
if(open.isConnected){if(keyboardOpen)open.focus({preventScroll:true});else open.blur();}
},{once:true});
return;
}
const dialog=event.target.closest('.vp-story-dialog');
if(!dialog)return;
if(event.target.closest('[data-vp-story-close]')){dialog.close();return;}
const step=event.target.closest('[data-vp-story-step]');
if(step){selectStory(dialog,Number(step.dataset.vpStoryStep));return;}
if(event.target===dialog){const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();}
});
document.addEventListener('pointerdown',function(event){
const dialog=event.target.closest('.vp-story-dialog[open]');
if(!dialog||!event.isPrimary||event.button!==0||event.target.closest('button,a,input,textarea,select'))return;
const panel=event.target.closest('[data-vp-story-panel]');
if(!panel)return;
const content=panel.querySelector('.vp-story-panel__content');
gestures.set(dialog,{pointerId:event.pointerId,x:event.clientX,y:event.clientY,time:event.timeStamp,content,scrollTop:content.scrollTop});
const state=animations.get(dialog);
if(state){state.held=true;syncPause(dialog);}
});
['pointerup','pointercancel'].forEach(type=>document.addEventListener(type,function(event){
document.querySelectorAll('.vp-story-dialog[open]').forEach(dialog=>{
const gesture=gestures.get(dialog);
gestures.delete(dialog);
const state=animations.get(dialog);
if(state){state.held=false;syncPause(dialog);}
if(type!=='pointerup'||!gesture||gesture.pointerId!==event.pointerId||event.timeStamp-gesture.time>350||Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>10||Math.abs(gesture.content.scrollTop-gesture.scrollTop)>2||!dialog.contains(event.target)||event.target.closest('button,a,input,textarea,select'))return;
const bounds=dialog.getBoundingClientRect();
selectStory(dialog,Number(dialog.dataset.vpStoryIndex)+(event.clientX<bounds.left+bounds.width/2?-1:1));
});
}));
document.addEventListener('focusin',function(event){
const dialog=event.target.closest('.vp-story-dialog[open]');
if(!dialog||event.target===dialog||!event.target.matches(':focus-visible'))return;
const state=animations.get(dialog);
if(state){state.paused=true;syncPause(dialog);}
});
document.addEventListener('visibilitychange',function(){document.querySelectorAll('.vp-story-dialog[open]').forEach(syncPause);});
document.addEventListener('keydown',function(event){
const dialog=document.querySelector('.vp-story-dialog[open]');
if(!dialog)return;
if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();selectStory(dialog,Number(dialog.dataset.vpStoryIndex)+(event.key==='ArrowRight'?1:-1));}
if(event.code==='Space'&&!event.target.closest('button,a,input,textarea,select')){event.preventDefault();const state=animations.get(dialog);if(state){state.paused=!state.paused;syncPause(dialog);}}
});
})();
  } catch(e) { console.error(e); }
})();

})();
